module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-20.df1c4aea.svg";